/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import React from 'react';
import PropTypes from 'prop-types';
import Account from './context/Account.js';
import Modal from './context/Modal.js';
import Theme from './context/Theme.js';
import ToastNotification from './context/ToastNotification.js';
import HelpPanel from './context/HelpPanel.js';
import DataHookMock from './context/DataHookMock.js';

/* eslint-disable react/jsx-props-no-spreading */
var Provider = function Provider(_ref) {
  var enableAutoMocking = _ref.enableAutoMocking,
    mock = _ref.mock,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(DataHookMock.Provider, {
    enableAutoMocking: enableAutoMocking,
    mock: mock
  }, /*#__PURE__*/React.createElement(Theme.Provider, null, /*#__PURE__*/React.createElement(Account.Provider, {
    mock: mock
  }, /*#__PURE__*/React.createElement(ToastNotification.Provider, null, /*#__PURE__*/React.createElement(Modal.Provider, {
    hideFromDom: mock
  }, /*#__PURE__*/React.createElement(HelpPanel.Provider, {
    hideFromDom: mock
  }, children))))));
};
Provider.propTypes = {
  children: PropTypes.node.isRequired,
  mock: PropTypes.bool,
  enableAutoMocking: PropTypes.bool
};
var Provider$1 = Provider;

export { Provider$1 as default };
